import { ACTION_TYPE } from './action';

// region Reducer
const visitStatusList = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_GET_MEMBER_VISIT_STATUS_SELECT_SUCCESS:
      return {
        ...state,
        selects: action.selects,
      };
    case ACTION_TYPE.CALL_API_GET_VISIT_STATUS_MEMBER_SUCCESS:
      return {
        ...state,
        datas: action.datas,
      };
    case ACTION_TYPE.CALL_API_DELETE_VISIT_STATUS_SUCCESS:
      return {
        ...state,
        isDeleteSuccess: true,
      };
    case ACTION_TYPE.RESET_MEMBER_VISIT_STATUS_FLG:
      return {
        ...state,
        isDeleteSuccess: false,
      };
    default:
      return state;
  }
};

export default visitStatusList;
